
export const defaultLocale = 'th';
export const localeOptions=[
    { id:'th',name:'Thai',icon:'flag-icon-th', short:'(TH)'},
    { id:'en',name:'English',icon:'flag-icon-us', short:'(US)'}
    
    
];
